import { useCallback } from 'react';

import Pagination from '@libComponents/Pagination';

import useYearlyTimesheets, {
    SET_PAGE_NUMBER,
    SET_PAGE_SIZE
} from './useYearlyTimesheets';

const _Pagination = () => {
    const [{ currentPage, totalPages, pageSize }, dispatch] =
        useYearlyTimesheets();

    const handlePageChange = useCallback(
        (event, value) => {
            dispatch({
                type: SET_PAGE_NUMBER,
                payload: value
            });
        },
        [dispatch]
    );

    const handleRowsPerPageChange = useCallback(
        (value) => {
            dispatch({
                type: SET_PAGE_SIZE,
                payload: value
            });
        },
        [dispatch]
    );

    return (
        !!totalPages && (
            <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                sx={{ display: 'flex', justifyContent: 'center' }}
                isRowsPerPageVarient={true}
                rowsPerPageProps={{
                    name: 'adminYearlyTimesheet',
                    onChange: handleRowsPerPageChange,
                    value: pageSize
                }}
            />
        )
    );
};

export default _Pagination;
